import { React, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridTable from "../../../../../components/GridTable";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import { Slider } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  tableElement: {
    margin: "4%",
  },
  parametersTitle: {
    borderBottom: "1px solid #FF7E67",
    marginTop: "10%",
    marginLeft: "3%",
    width: "70%",
  },
}));

const DeepParameters = () => {
  const [state, setState] = useState({
    checkedA: true,
    checkedB: true,
  });
  const classes = useStyles();

  const handleChangeSwitch = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (
    <>
      <div className={classes.parametersTitle}>
        <h3>Parameters</h3>
      </div>
      <div className={classes.tableElement}>
        <GridTable
          tableContent={[
            {
              key: <span style={{ fontWeight: "bold" }}>Epoch:</span>,
              value: <TextField label="0-45" />,
            },
          ]}
          keySize={4}
          valueSize={6}
        />
      </div>
      <div className={classes.tableElement}>
        <GridTable
          tableContent={[
            {
              key: <span style={{ fontWeight: "bold" }}>Batch Size:</span>,
              value: <TextField label="0-10" />,
            },
          ]}
          keySize={4}
          valueSize={6}
        />
      </div>

      <div className={classes.tableElement}>
        <GridTable
          tableContent={[
            {
              key: <span style={{ fontWeight: "bold" }}>Split Flag:</span>,
              value: (
                <Switch
                  checked={state.checkedA}
                  onChange={handleChangeSwitch}
                  name="checkedA"
                  inputProps={{ "aria-label": "secondary checkbox" }}
                />
              ),
            },
          ]}
          keySize={4}
          valueSize={6}
        />
      </div>
      <div className={classes.tableElement}>
        <GridTable
          tableContent={[
            {
              key: <span style={{ fontWeight: "bold" }}>Test split:</span>,
              value: (
                <Slider
                  defaultValue={0.2}
                  style={{ width: "50%" }}
                  min={0}
                  step={0.1}
                  max={1}
                  valueLabelDisplay="auto"
                />
              ),
            },
          ]}
          keySize={4}
          valueSize={6}
        />
      </div>
      <div className={classes.tableElement}>
        <GridTable
          tableContent={[
            {
              key: <span style={{ fontWeight: "bold" }}>Early Stop:</span>,
              value: (
                <Switch
                  checked={state.checkedB}
                  onChange={handleChangeSwitch}
                  color="primary"
                  name="checkedB"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              ),
            },
          ]}
          keySize={4}
          valueSize={6}
        />
      </div>
    </>
  );
};

export default DeepParameters;
